import EnumService from '../EnumService'

export default class TipoFrequenciaEnumService extends EnumService{

    constructor(){
        super('enumTipoFrequencia');
    }
  
  }